import React from 'react';

export default function SubSectionHeader({ label }) {
  return (
    <div className="w-full flex justify-start items-center mb-2">
      <h2 className="text-md font-medium text-neutral-900 m-0 p-0">{label}</h2>
    </div>
  );
}
